export function resolveAudience() {
    // 1) Meta tag
    if (typeof document !== 'undefined') {
        const meta = document.querySelector('meta[name="idp-audience"]');
        const val = meta?.content?.trim();
        if (val === 'teetime-admin')
            return 'teetime-admin';
        if (val === 'cmp-portal')
            return 'cmp-portal';
        if (val === 'voicepro-web')
            return 'voicepro-web';
        if (val === 'scl-admin')
            return 'scl-admin';
        if (val === 'yolo-admin')
            return 'yolo-admin';
    }
    // 2) Window config
    if (typeof window !== 'undefined') {
        const w = window;
        if (w.APP_CONFIG?.idpAudience === 'teetime-admin')
            return 'teetime-admin';
        if (w.APP_CONFIG?.idpAudience === 'cmp-portal')
            return 'cmp-portal';
        if (w.APP_CONFIG?.idpAudience === 'voicepro-web')
            return 'voicepro-web';
        if (w.APP_CONFIG?.idpAudience === 'scl-admin')
            return 'scl-admin';
        if (w.APP_CONFIG?.idpAudience === 'yolo-admin')
            return 'yolo-admin';
    }
    const env = globalThis.process?.env;
    const audience = env?.['VITE_IDP_AUDIENCE'];
    if (audience === 'teetime-admin')
        return 'teetime-admin';
    if (audience === 'cmp-portal')
        return 'cmp-portal';
    if (audience === 'voicepro-web')
        return 'voicepro-web';
    if (audience === 'scl-admin')
        return 'scl-admin';
    if (audience === 'yolo-admin')
        return 'yolo-admin';
    return 'teetime-web';
}
//# sourceMappingURL=resolveAudience.js.map